import { Stack, PrimaryButton, Text } from "@certn/cascadia";
import { Card, ColorPickerFormikField, Icon } from "@certn/cascadia-react";
import { Trans } from "react-i18next";
import { Formik, Form } from "formik";
import { generateWCAGMessage, isWCAGCompliant } from "./utils";
import { useColorForm } from "./hooks/useColorForm";
import { ColorSummaryCard } from "./ColorSummaryCard";
interface ColorCustomizationFormProps {
  onColorChange: (color: string) => void;
}

export function PrimaryColorForm({
  onColorChange,
}: ColorCustomizationFormProps) {
  const {
    initialValues,
    isSubmitting,
    isFetchingColor,
    applyChanges,
    handleSubmit,
    handleReset,
    handleColorChange,
    handleCancel,
  } = useColorForm({ onColorChange });

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ setFieldValue, submitForm, resetForm, values }) => (
        <Form>
          <Stack>
            <Card hideBorder>
              <Stack gap="space-4">
                <ColorPickerFormikField
                  isRequired
                  name="primaryColor"
                  label="Primary Color"
                  testID="primary-color-picker"
                  onDone={(color) => handleColorChange(color, setFieldValue)}
                  onReset={() => handleReset(resetForm, setFieldValue)}
                  onCancel={() => handleCancel(setFieldValue)}
                />
              </Stack>
            </Card>

            <Stack orientation="horizontal" gap="space-2">
              {isWCAGCompliant(values.primaryColor) && (
                <Icon
                  name="check"
                  type="standard"
                  color="text-success"
                  size="space-4"
                />
              )}
              <Text
                style="global/body-secondary"
                color={
                  isWCAGCompliant(values.primaryColor)
                    ? "text-success"
                    : undefined
                }
              >
                {generateWCAGMessage(values.primaryColor)}
              </Text>
            </Stack>

            <ColorSummaryCard primaryColor={values.primaryColor} />
            <PrimaryButton
              variant="brand-primary"
              onPress={submitForm}
              isDisabled={isSubmitting || isFetchingColor || !applyChanges}
              isLoading={isSubmitting}
              testID="apply-changes-button"
            >
              <Trans>Apply changes</Trans>
            </PrimaryButton>
          </Stack>
        </Form>
      )}
    </Formik>
  );
}
